import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponents = {
  variant: "layout",
  data: {
    type: "table",
    options: {
      cols: 9,
      rows: 3,
      colSpan: {
        "0:0": 9,
        "2:1": 2,
        "2:4": 2,
        "2:7": 2,
      },
      rowSpan: {
        "1:0": 2,
        "1:3": 2,
        "1:6": 2,
      },
      rowsSize: [4.5, 0.3, 1],
      colsSize: [1.5, 0.5, 1.3, 1.5, 0.5, 1.3, 1.5, 0.5, 1.3],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/recycled-textile-house.svg`,
                },
              },
            },
          },
        ],
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/recycled-textile-rolls.png`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/recycled-textile-1.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingLeft: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/recycled-textile-rigid.png`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/recycled-textile-2.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingLeft: "5%",
              },
            },
          },
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/loose-recycled-textile-rolls.png`,
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/05/27/principle/recycled-textile-3.svg`,
                  styles: {
                    minHeight: "25px",
                    minWidth: "25px",
                    maxHeight: "40px",
                    maxWidth: "40px",
                  },
                },
              },
              styles: {
                justifyContent: "flex-start",
                paddingLeft: "5%",
              },
            },
          },
          null,
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Recycled textile rolls (cotton wool)</b> having porous absorption properties",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3%",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "<b>Recycled textile rigid panels</b> having porous absorption properties (can be exposed)",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3%",
                justifyContent: "flex-start",
              },
            },
          },
          null,
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data:
                    "<b>Loose recycled textile rolls</b> to be blown-in or stuffed in a partition and having porous absorption properties",
                  scrollbars: false,
                  formatter: "html",
                  styles: {
                    fontSize: "10px",
                  },
                },
              },
              styles: {
                alignItems: "flex-start",
                padding: "0 3%",
                justifyContent: "flex-start",
              },
            },
          },
        ],
      ],
    },
  },
};

export default components;
